import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";

export function useConnections() {
  const [connections, setConnections] = useState([]);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const [connRes, pendRes] = await Promise.all([
        axios.get(`${API}/connections`, { withCredentials: true }),
        axios.get(`${API}/connections/pending`, { withCredentials: true }),
      ]);
      setConnections(connRes.data);
      setPending(pendRes.data);
    } catch {
      setConnections([]);
      setPending([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  const sendInvite = async (email) => {
    const res = await axios.post(`${API}/connections`, { email }, { withCredentials: true });
    return res.data;
  };

  const accept = async (inviteId) => {
    const res = await axios.post(`${API}/connections/${inviteId}/accept`, {}, { withCredentials: true });
    setPending(prev => prev.filter(p => p.invite_id !== inviteId));
    setConnections(prev => [...prev, res.data]);
    return res.data;
  };

  const decline = async (inviteId) => {
    await axios.post(`${API}/connections/${inviteId}/decline`, {}, { withCredentials: true });
    setPending(prev => prev.filter(p => p.invite_id !== inviteId));
  };

  const remove = async (userId) => {
    await axios.delete(`${API}/connections/${userId}`, { withCredentials: true });
    setConnections(prev => prev.filter(c => c.user_id !== userId));
  };

  return { connections, pending, loading, sendInvite, accept, decline, remove, refetch: fetch };
}
